/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import SvgIcon from "./SvgIcon";

export type FieldGroupProps = React.ComponentPropsWithoutRef<"div"> & {
  label?: string;
  info?: string;
  required?: boolean;
  errorMessage?: string;
};

const FieldGroup = (props: FieldGroupProps): React.Component => {
  const { label, info, required, errorMessage, children, ...rest } = props;
  const invalid = !!errorMessage;

  return (
    <div className={`${label && "mb-3"} ${invalid && "field-group--invalid"}`} {...rest}>
      {label && <label className="label">{label}</label>}
      {required && <sup style={{ color: "red" }}>*</sup>}
      {info && (
        <span
          className="help"
          data-bs-toggle="tooltip"
          data-trigger="hover"
          data-placement="right"
          data-html="true"
          data-container="body"
          title={info}
        >
          <SvgIcon name="question-circle" className="ml-1 label" />
        </span>
      )}
      {children}
      {invalid && (
        <div className="field-helper">
          <label>{errorMessage}</label>
        </div>
      )}
    </div>
  );
};

FieldGroup.displayName = "FieldGroup";

export default FieldGroup;
